<template>
  <div>
    <span>Selecione uma Imagem</span>
    <q-file dense outlined v-model="file">
      <template v-slot:prepend>
        <q-icon name="attach_file" />
      </template>
    </q-file>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
export default {
  emits: ["enviarBase64"],
  props: ["model"],
  setup(props, { emit }) {
    let file = ref(props.model);
    let imageUrl = ref("");

    const verificarImagem = () => {
      if (props.model != "") {
        file.value = props.model;
      }
      if (file.value != null && file.value != undefined && file.value != "") {
        if (!file.value.name && file.value.includes("https:")) {
          toBase64(imageUrl, function (base64String) {
            emit(
              "enviarBase64",
              `data:image/png;${base64String.split(";")[1]}`,
              file.value
            );
          });
          file.value = {
            lastModified: "",
            name: "Imagem Produto",
            url: file.value,
            size: "",
            type: "",
            webkitRelativePath: "",
          };
          return;
        }
        if (file.value.type) {
          let fileReader = new FileReader();
          fileReader.readAsDataURL(file.value);
          fileReader.addEventListener("load", () => {
            imageUrl.value = fileReader.result;
            emit("enviarBase64", imageUrl.value, file.value);
          });
        }
      }
    };

    const toBase64 = (url, callback) => {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    };

    watch(
      () => file.value,
      () => {
        if (file.value != null && file.value != "" && file.value != undefined) {
          if (file.value.name == "Imagem Produto") {
            return;
          }
          if (!file.value.name && file.value.includes("https:")) {
            toBase64(imageUrl, function (base64String) {
              emit(
                "enviarBase64",
                `data:image/png;${base64String.split(";")[1]}`,
                file.value
              );
            });
            file.value = {
              lastModified: "",
              name: "Imagem Produto",
              size: "",
              type: "",
              webkitRelativePath: "",
            };
            return;
          }
          if (file.value.type) {
            let fileReader = new FileReader();
            fileReader.readAsDataURL(file.value);
            fileReader.addEventListener("load", () => {
              imageUrl.value = fileReader.result;
              emit("enviarBase64", imageUrl.value, file.value);
            });
          }
        }
      }
    );
    watch(
      () => props.model,
      () => {
        file.value = props.model;
      }
    );

    onMounted(verificarImagem);

    return {
      file,
      verificarImagem,
      toBase64,
    };
  },
};
</script>
